import { render, staticRenderFns } from "./SearchUserPage.vue?vue&type=template&id=8f80f3da&scoped=true"
import script from "./SearchUserPage.vue?vue&type=script&lang=js"
export * from "./SearchUserPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f80f3da",
  null
  
)

export default component.exports